import styled from 'styled-components';
import Typography from '../../theme/typography';
import StyledIcon from '../../atoms/Icon/styles';
import {StyledProps, StyledBodyProps, StyledHeaderProps} from './typings';
import colors from '../../theme/constants/colors';
import {sizePx} from '@/theme/helpers/size';
import focus from '@/theme/focus';

const StyledAccordion = styled.section<StyledProps>`
  padding: 0;
  overflow: visible;
  ${(props) =>
    props.$hasDividers &&
    `
  border-top: 1px solid ${colors.grey50};
  border-bottom: 1px solid ${colors.grey50};

  ${StyledAccordion} + ${StyledAccordion}{
    border-top: none;
  }
`}
`;

export const StyledAccordionHeader = styled.div<StyledHeaderProps>`
  position: relative;
  padding: ${sizePx(8)} 0;
  ${(props) => props.$collapsible && 'cursor: pointer;'}

  ${focus.brand()}

  ${StyledIcon}.icon-minus, 
  ${StyledIcon}.icon-plus {
    position: absolute;
    top: 21px;
    right: 0;
  }

  h4 {
    ${(props) => (props.$strongTitle === true ? Typography.Subtitle1 : Typography.Body1)}
  }

  p {
    ${Typography.Body3}
  }
`;

export const StyledAccordionBody = styled.div<StyledBodyProps>`
  display: ${(props) => (props.$open === true ? 'block' : 'none')};
  padding: ${sizePx(4)} 0 ${sizePx(10)};
`;

export default StyledAccordion;
